import type { Transition, Variants } from "framer-motion";

export const APP_SPRING: Transition = {
    type: "spring",
    stiffness: 300,
    damping: 30,
};

export const BUBBLE_ENTER_TRANSITION: Transition = {
    type: "tween",
    duration: 0.24,
    ease: [0.215, 0.61, 0.355, 1],
};

export const BUBBLE_SETTLE_SPRING: Transition = {
    type: "spring",
    duration: 0.22,
    bounce: 0,
};

export const GENTLE_SPRING: Transition = {
    type: "spring",
    stiffness: 240,
    damping: 28,
};

export const SOFT_SPRING: Transition = {
    type: "spring",
    stiffness: 200,
    damping: 22,
};

export const POP_SPRING: Transition = {
    type: "spring",
    stiffness: 500,
    damping: 25,
};

export const SNAPPY_SPRING: Transition = {
    type: "spring",
    stiffness: 500,
    damping: 40,
};

export const DEAL_SPRING = {
    type: "spring" as const,
    stiffness: 180,
    damping: 26,
};

const CARD_STAGGER = 0.05;

export const EASE_OUT_QUAD = [0.25, 0.46, 0.45, 0.94] as const;

export const cardVariants: Variants = {
    hidden: { opacity: 0, y: 16 },
    visible: (i: number) => ({
        opacity: 1,
        y: 0,
        transition: {
            ...APP_SPRING,
            delay: i * CARD_STAGGER,
        },
    }),
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: { duration: 0.2, ease: EASE_OUT_QUAD },
    },
};

export const cardVariantsReduced: Variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0 } },
    exit: { opacity: 0 },
};

export const emptyStateVariants: Variants = {
    hidden: { opacity: 0, y: 8 },
    visible: { opacity: 1, y: 0, transition: APP_SPRING },
    exit: { opacity: 0, y: 8, transition: { duration: 0.15 } },
};

export const emptyStateVariantsReduced: Variants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0 } },
    exit: { opacity: 0, transition: { duration: 0 } },
};

export const mountEntrance = (
    prefersReducedMotion: boolean | null,
    delay = 0,
) =>
    prefersReducedMotion
        ? {
              initial: { opacity: 1 } as const,
              animate: { opacity: 1, y: 0 } as const,
              transition: { duration: 0 },
          }
        : {
              initial: { opacity: 0, y: 12 } as const,
              animate: { opacity: 1, y: 0 } as const,
              transition: { ...APP_SPRING, delay },
          };

export const staggerParentVariants = (stagger = 0.12, delay = 0): Variants => ({
    hidden: {},
    show: { transition: { staggerChildren: stagger, delayChildren: delay } },
});

export const staggerChildVariants: Variants = {
    hidden: { opacity: 0, y: 16 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.3, ease: [0.25, 1, 0.5, 1] },
    },
};
